<script lang="ts">
  import type { Job } from "@puntocrypto/core";

  export let status: Job["status"] = { type: "ok" };

  let color: string;
  let text = "Ready";

  $: {
    switch (status.type) {
      case "failed":
        text = "Failed";
        color = "bg-red-500 ring-red-500";
        break;
      case "running":
        text = "Running";
        color = "bg-yellow-500 ring-yellow-500";
        break;
      case "ok":
        text = "Ok";
        color = "bg-green-500 ring-green-500";
        break;
      case "new":
      default:
        text = "Ready";
        color = "bg-gray-500 ring-gray-500";
        break;
    }
  }
</script>

<div class="inline-flex items-center mr-4 px-4 py-2">
  <span class="rounded-full w-2 h-2 mr-2 ring-1 {color} ring-offset-2" />
  <span class="capitalize font-semibold text-xs">status: {text}</span>
</div>
